/* eslint-disable */
export const checkForTags = (html) => {
  const forbiddenTags = /<(script|link|meta|style)\b[^>]*?>/i;
  if (forbiddenTags.test(html)) return true;

  const classRegex = /<[^>]+\bclass=("|')([^"']+)\1[^>]*>/gi;
  const excludedClasses = new Set(['img-responsive', 'embed-responsive', 'note-video-clip', 'embed-responsive-item']);

  let match;
  while ((match = classRegex.exec(html)) !== null) {
    const classes = match[2].trim().split(/\s+/);
    if (classes.some(cls => cls && !excludedClasses.has(cls))) {
      return true;
    }
  }

  return false;
}

export const processHtml = (html) => {
  let processed = html.replace(/<style[^>]*>([\s\S]*?)<\/style>/gi, (match, content) => {
    content = content
      .replace(/([.#])(?!p-note-)([a-zA-Z_-][\w-]*)/g, '$1p-note-$2')
      .replace(/(^|,| |\t|>|\+|\n)(\s*)([a-zA-Z]+)(?=[, {]|$)/g, '$1$2.p-note $3');
    return `<style>${content}</style>`;
  });

  const excludedClasses = new Set([
    'img-responsive',
    'embed-responsive',
    'note-video-clip',
    'embed-responsive-item',
    'p-note'
  ]);

  processed = processed.replace(/<([a-z][a-z0-9]*)([^>]*)>/gi, (match, tag, rest) => {
    const newRest = rest.replace(/\bclass=("|')([^"']+)\1/gi, (m, q, cls) => {
      const classes = cls
        .trim()
        .split(/\s+/)
        .filter(c => c)
        .map(c => excludedClasses.has(c) ? c : `p-note-${c}`)
        .join(' ');
      return `class=${q}${classes}${q}`;
    });
    return `<${tag}${newRest}>`;
  });

  processed = processed.replace(/(<script\b[^>]*>[\s\S]*?<\/script>|<link\b[^>]*>|<meta\b[^>]*>)/gi, (match) => {
    return `<!--P_NOTE-START--${match}--P_NOTE-END-->`;
  });

  processed = processed.replace(/\\"/g, '"');

  processed = processed.replace(/\\n/g, '');

  return processed;
}


export const revertHtml = (html) => {
  let previous;
  do {
    previous = html;
    html = html.replace(/<!--P_NOTE-START--/g, '')
      .replace(/--P_NOTE-END-->/g, '');
  } while (html !== previous);


  html = html.replace(/\bclass=(["'])(.*?)\1/g, (_, quote, classes) => {
    const cleaned = classes.split(/\s+/)
      .map(c => c.replace(/^p-note-/, ''))
      .join(' ');
    return `class=${quote}${cleaned}${quote}`;
  });


  html = html.replace(/<style>([\s\S]*?)<\/style>/g, (_, content) => {
    return `<style>${content
      .replace(/\.p-note-([a-zA-Z_-]+)/g, '.$1')
      .replace(/#p-note-([a-zA-Z_-]+)/g, '#$1') // Добавлена обработка ID
      .replace(/\.p-note\b/g, '')
      .replace(/\.p-note ([a-zA-Z]+)/g, '$1')
    }</style>`;
  });

  return html;
}
